import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import SEO from "../components/commonComponents/SEO";
import HeroBanner from "../components/commonComponents/HeroBanner";
import BackgroundEffects from "../components/commonComponents/BackgroundEffects";
import CommonCTA from "../components/commonComponents/CommonCTA";
import { productsData } from "../data/productData";
import ProductIntro from "../components/products/ProductIntro";
import ProductPoints from "../components/products/ProductPoints";
import NotFoundPage from "./NotFoundPage";
const SITE_URL = "https://www.zencon-sa.com";

const ProductPage = () => {
  const { slug } = useParams();
  const product = productsData[slug];

  if (!product) {
    return <NotFoundPage />;
  }

  const pageUrl = `${SITE_URL}/products/${slug}`;

  return (
    <>
      <SEO
        title={product.seo?.title || `${product.title} | ZENCON`}
        description={
          product.seo?.description || `${product.title} solution by ZENCON.`
        }
        keywords={
          product.seo?.keywords || `${product.title}, SAP solution, ZENCON`
        }
        url={pageUrl}
        image={
          product.seo?.image ||
          "https://www.zencon-sa.com/images/default-seo.png"
        }
      />

      <HeroBanner title={product.title} subtitle={product.subtitle} />

      <Box
        sx={{
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
          background:
            "linear-gradient(135deg, #f7fbff 0%, #eef7f4 45%, #f8fbff 100%)",
        }}
      >
        <BackgroundEffects />

        <ProductIntro
          image={product.componentOne.image}
          title={product.componentOne.title}
          description={product.componentOne.description}
        />

        <ProductPoints
          features={product.componentTwo.leftGrid}
          benefits={product.componentTwo.rightGrid}
        />

        {product?.componentThree && (
          <ProductIntro
            reverse
            image={product.componentThree.image}
            title={product.componentThree.title}
            description={product.componentThree.description}
          />
        )}

        <CommonCTA />
      </Box>
    </>
  );
};

export default ProductPage;
